import { APIOps } from "@/apis/api-config";
import ApiPaths from "@/apis/base-api-paths";

// カラーミーショップ 明示連携（認証済み /api/app/colorme/*）
export default class AppColormeApi extends ApiPaths {
  async getStatus(): Promise<
    APIOps["colorme_link_status_api_app_colorme_status_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toColormeURL("status"))).data;
  }

  async link(
    props: APIOps["colorme_link_api_app_colorme_link_post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["colorme_link_api_app_colorme_link_post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post(this.toColormeURL("link"), props)).data;
  }

  // 引換券だけで紐付ける（カラーミーショップの認証をもう一度回さない）
  async linkByTicket(
    props: APIOps["colorme_link_by_ticket_api_app_colorme_link_by_ticket_post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["colorme_link_by_ticket_api_app_colorme_link_by_ticket_post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post(this.toColormeURL("link-by-ticket"), props)).data;
  }

  async unlink(
    shopId: string,
  ): Promise<
    APIOps["colorme_unlink_api_app_colorme_link__shop_id__delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(this.toColormeURL(`link/${shopId}`))).data;
  }

  // カラーミー限定プランの利用権（契約状態 + 適用先Instagramアカウント）
  async getEntitlement(): Promise<
    APIOps["colorme_entitlement_status_api_app_colorme_entitlement_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(this.toColormeURL("entitlement"))).data;
  }

  // インストール成功画面の表示情報（認証不要）。
  // URLのクエリをそのまま信じず、実際にインストール済みのショップかを確認する。
  async getInstalledShop(
    shopId: string,
  ): Promise<
    APIOps["colorme_installed_shop_api_public_colorme_installed_shop_get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.get(this.toPublicColormeURL("installed-shop"), {
        params: { shop: shopId },
      })
    ).data;
  }

  // 適用先Instagramアカウントの設定・変更（月1回まで）
  async updateEntitlement(
    props: APIOps["update_colorme_entitlement_api_app_colorme_entitlement_put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIOps["update_colorme_entitlement_api_app_colorme_entitlement_put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(this.toColormeURL("entitlement"), props)).data;
  }
}
